module.exports = __webpack_public_path__ + "quicksilver/static/media/citi.652fe4aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/citi.svg
// module id = 640
// module chunks = 0